import { createAction, props } from '@ngrx/store';

export enum PolicyCancellationActionTypes {
  Init = '[PolicyCancellation Page] Init',
  CancelPolicyClicked = '[PolicyCancellation Page] Cancel Policy Clicked',
}

export const PolicyCancellationActions = {
  init: createAction(PolicyCancellationActionTypes.Init),
  cancelPolicyClicked: createAction(
    PolicyCancellationActionTypes.CancelPolicyClicked,
    props<{ cancelReason: string; cancellationDate: string }>()
  ),
};
